import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleContactNumber = {
  namespaced: true,

  state: {
    name: 'contactNumber',
    contactNumbers: []
  },

  mutations,
  getters,
  actions
}

export default moduleContactNumber;